import React from 'react'
import RecentUpdateCard from '../../../common/card/RecentUpdateCard'

const RecentUpdates = ( { recentContent = [] } ) => {
  
    return (
        <div className='msync-recent-updates-container'>
            <h5>Recent Updates</h5>
            <div className='msync-recent-updates'>
                {
                    recentContent.legth > 0 ? recentContent.map( ( content, key ) => {
                        return(
                            <RecentUpdateCard
                                key={key}
                                hasDate={content.date}
                                content={content.message}
                             />
                        )
                    }) :
                    <span>
                        No updates
                    </span>
                }
            </div>
        </div>
    )
}

export default RecentUpdates